import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string

// 🔍 DIAGNOSTICS: Log actual Supabase URL being used
console.log('🔍 [SUPABASE CLIENT] URL:', url)
console.log('🔍 [SUPABASE CLIENT] ANON KEY (first 20 chars):', anon?.substring(0, 20))

export const supabase = createClient(url, anon, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
})

export default supabase